<template>
  <div class="agencyItem">
    <div class="contain">
      <van-card :title="item.title" :thumb="img">
        <template #bottom>{{ item.pubDate }}</template>
      </van-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "agencyItem",
  data() {
    return {
      urlImg: process.env.VUE_APP_API_IMGURL
    };
  },
  props: {
    item: {
      default: () => {
        return {};
      },
      type: Object,
      required: true
    }
  },
  methods: {},
  computed: {
    img() {
      if (this.item.serviceThumbnail) {
        return `${this.urlImg}${this.item.servicePictures[0].imgUrl}`;
      } else {
        return `${require("@/assets/images/policyInfo.png")}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.agencyItem {
  height: 145px;
}
.van-nav-bar {
  ::v-deep {
    .van-icon {
      color: #000;
      font-size: 20px;
      font-weight: 700;
    }

    .van-nav-bar__text {
      padding-left: 10px;
      font-size: 20px;
      color: #000;
      font-weight: normal;
    }
  }
}
.van-card {
  ::v-deep {
    .van-card__thumb {
      margin-top: 8px;
      height: 100px;
      width: 80px;
      margin-right: 20px;
    }

    .van-card__title {
      // box-sizing: border-box;
      flex-shrink: 0;
      margin-top: 10px;
      opacity: 1;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      color: #222222;
      // overflow: hidden;
      // -webkit-line-clamp: 2;//设置显示文本的行数
      max-height:42px;
    }
  }
  .phone {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .van-icon {
      color: #4eaefc;
      font-size: 14px;
    }
    span {
      margin-left: 10px;
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #757a8c;
      line-height: 24px;
    }
    & > span:nth-child(2) {
      display: inline-block;
      background-color: #d2eeff;
      padding: 0 5px;
      height: 18px;
      opacity: 1;
      font-size: 10px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: center;
      color: #7dceff;
      line-height: 18px;
      border-radius: 3px;
    }
  }
  .message {
    display: flex;
    .van-icon {
      color: #4eaefc;
      font-size: 14px;
      margin-top: 5px;
    }

    span {
      margin-left: 6px;
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #757a8c;
      line-height: 24px;
    }
  }
}
.contain {
  height: 100%;
  border-bottom: 4px solid #e9f6ff;
}
</style>
